import { makeStyles } from "@material-ui/styles";

export default makeStyles(theme => ({
  tabs: {
    marginBottom: theme.spacing(3),
  },
  // Let the table size to its content instead of stretching full width, so
  // each column (Rank especially) is only as wide as it needs to be, and pack
  // everything to the left.
  table: {
    "& table": {
      width: "auto",
    },
    "& th, & td": {
      textAlign: "left",
      whiteSpace: "nowrap",
    },
  },
}));
